var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9429 11.1299L8.69839 7.76963C8.44218 7.50603 8.02338 7.5011 7.75978 7.75731C7.63167 7.87803 7.55777 8.04555 7.5553 8.22292C7.55037 8.4003 7.61935 8.57029 7.74007 8.69593L10.9846 12.0562L7.62428 15.3007C7.36068 15.5569 7.35575 15.9757 7.61196 16.2393C7.73268 16.3674 7.9002 16.4413 8.07757 16.4438C8.25495 16.4487 8.42493 16.3797 8.55058 16.259L11.9109 13.0145L15.1554 16.3748C15.4116 16.6384 15.8304 16.6433 16.094 16.3871C16.2221 16.2664 16.296 16.0989 16.2984 15.9215C16.3034 15.7441 16.2344 15.5742 16.1137 15.4485L12.8692 12.0882L16.2295 8.84374C16.4931 8.58753 16.498 8.16873 16.2418 7.90513C16.1211 7.77702 15.9535 7.70311 15.7762 7.70065C15.5988 7.69572 15.4288 7.7647 15.3032 7.88542L11.9429 11.1299ZM4.80598 18.9468C0.970228 14.9731 1.08109 8.64419 5.05233 4.80598C9.02604 0.970228 15.3549 1.08109 19.1931 5.05233C23.0289 9.02604 22.9205 15.3549 18.9468 19.1931C14.9731 23.0289 8.64419 22.9205 4.80598 18.9468Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.493e710149f5b24f7ddceb1463b69ebe.svg";
export { ForwardRef as ReactComponent };